import { Component, ViewChild } from "@angular/core";
import { Catalog, Page, Element } from "@app/data/catalog";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Listing } from "@app/data/listing";

import { ListingCartItem, Customer } from "shopping/cart";
import { AfterViewInit } from "@angular/core";
import { SupermodalSuccessComponent } from "@app/components/common/supermodal-success.component";
import { Angulartics2 } from "angulartics2";
import { CustomerService } from "@app/services/customer.service";
import { CatalogService } from "@app/services/catalog.service";
import { Subject } from "rxjs";
import { UserService } from "@app/services/user.service";
import { DigitalOrderSheet } from "@app/data/digital-order-sheet";
import { DigitalOrderSheetService } from "@app/services/digital-order-sheet.service";
import { CartService } from "shopping/cart.service";

@Component({
  templateUrl: "./complete-order.component.html",
})
export class CompleteOrderComponent {
  @ViewChild("supermodalSuccess")
  supermodalSuccessComponent: SupermodalSuccessComponent;

  customer: Customer = new Customer();
  comments: string;
  error: string;
  customerFound: boolean = false;
  subject: Subject<string>;
  id: string;
  isFromCatalog: boolean;
  catalog: Catalog;
  userId: string;
  digitalOrderSheet: DigitalOrderSheet;
  thankYouMessage: string = "Purchase Completed";

  constructor(
    private route: ActivatedRoute,
    protected angulartics2: Angulartics2,
    private router: Router,
    private cartService: CartService<ListingCartItem>,
    private userService: UserService,
    private catalogService: CatalogService,
    private digitalOrderSheetService: DigitalOrderSheetService
  ) {
    this.id = this.route.snapshot.params["id"];
    this.route.data.subscribe((data) => {
      let source = data.source;
      if (source === "catalog") {
        this.isFromCatalog = true;
        this.catalogService.getCatalog(this.id).then((catalog) => {
          this.catalog = catalog;
          this.userId = this.catalog.user._id;
        });
      } else if (source === "online store") {
        this.isFromCatalog = false;
        this.digitalOrderSheetService.get(this.id).then((digitalOrderSheet) => {
          this.digitalOrderSheet = digitalOrderSheet;
          this.thankYouMessage =
            this.digitalOrderSheet.thank_you_message || this.thankYouMessage;
          this.userId = this.digitalOrderSheet.user._id;
        });
      }
    });
  }

  // ngAfterViewInit(): void {
  //     this.subject = new Subject<string>();
  //     this.subject
  //         .debounceTime(200)
  //         .subscribe({
  //             next: (email) =>
  //                 this.userService.getCustomer(this.userId, email).then(customers => {
  //                     console.log('customer found', customers)
  //                     if (customers.length === 1) {
  //                         console.log('customer found ok')

  //                         this.customer.id = customers[0].id;
  //                         this.customerFound = true;
  //                     }
  //                 }).catch(error => {
  //                     this.error = error;
  //                 })
  //         });
  // }

  sendOrder() {
    this.userService
      .sendOrder(
        this.userId,
        this.customer,
        this.cartService.getItems(),
        this.comments
      )
      .then(() => {
        this.cartService.clear();
        this.supermodalSuccessComponent.open();
        this.angulartics2.eventTrack.next({
          action: "Order sent",
        });
      })
      .catch((error) => {
        this.error = error;
      });
  }

  searchCustomer() {
    this.subject.next(this.customer.email);
  }

  openShoppingCart() {
    if (this.isFromCatalog) {
      this.router.navigate([`/catalogs/${this.id}/order-sheet/shopping-cart`]);
    } else {
      this.router.navigate([`/digital-order-sheets/${this.id}/shopping-cart`]);
    }
  }

  moveToOrderSheet() {
    if (this.isFromCatalog) {
      this.router.navigate([`/catalogs/${this.id}/order-sheet/view`]);
    } else {
      this.router.navigate([`/digital-order-sheets/${this.id}/view`]);
    }
  }
}
